module.exports = __webpack_public_path__ + "img/Start2_or.61fc0ab9.jpg";